import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from '@xo-union/tk-component-icons';
import Collection from '~/glm/models/collection';
import styles from './meal-dropdown.scss';

export default class MealDropdown extends React.Component {
  static propTypes = {
    updateSelectedMeal: PropTypes.func,
    mealFilter: PropTypes.string,
    onClick: PropTypes.func,
    meals: PropTypes.instanceOf(Collection),
    showNoReply: PropTypes.bool,
    showCheckmark: PropTypes.bool,
    borders: PropTypes.bool,
    setMenuState: PropTypes.func,
  };

  showCheckmark(meal) {
    const { mealFilter, showCheckmark = false } = this.props;

    return showCheckmark && mealFilter === meal;
  }

  handleClick(meal) {
    const { onClick, setMenuState } = this.props;
    onClick(meal);

    if (setMenuState) {
      setMenuState(false);
    }
  }

  render() {
    const { meals, borders = false } = this.props;
    const noReplyMeal = {
      text: null,
    };

    return (
      <Fragment>
        {meals.map((meal, idx) => {
          return (
            <div
              key={idx}
              className={classnames(styles.mealDropdownCell, {
                [styles.mealDropdownCellWithBorder]: borders,
              })}
              onClick={() => this.handleClick(meal)}
            >
              <span>{meal.text}</span>
              {this.showCheckmark(meal.text) && <Icon className={styles.mealCheck} name="checkmark" />}
            </div>
          );
        })}
        <div
          className={classnames(styles.mealDropdownCell, {
            [styles.mealDropdownCellWithBorder]: borders,
          })}
          onClick={() => this.handleClick(noReplyMeal)}
        >
          <span className={styles.noChosenMealLabel}>No Reply</span>
          {this.showCheckmark('No Reply') && <Icon className={styles.mealCheck} name="checkmark" />}
        </div>
      </Fragment>
    );
  }
}
